export default __webpack_public_path__ + "static/media/navigation.4e3d40ee.jpg";